export default "__VITE_ASSET__CwTrhc3q__"